import { CommonModule } from "@angular/common";
import { Component, OnInit, forwardRef } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NavController,
  ToastController,
  LoadingController,
  NavParams,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";

@Component({
  selector: "app-acompanhamento-finalizar",
  templateUrl: "./acompanhamento-finalizar.page.html",
  styleUrls: ["./acompanhamento-finalizar.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule],
})
export class AcompanhamentoFinalizarPage implements OnInit {
  acompanhamento: any = {};
  statusList: any = [];
  validations_form: FormGroup;
  submitted = false;

  validation_messages = {
    idAcompanhamentoStatus: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    descricao: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
  };

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public navParams: NavParams
  ) {
    this.acompanhamento = this.navParams.get("acompanhamento");
    this.validations_form = this.formBuilder.group({
      idAcompanhamentoStatus: new FormControl("", Validators.required),
      descricao: new FormControl(this.acompanhamento?.descricao || "", [
        Validators.required,
        Validators.pattern(/\S+/),
      ]),
    });

    this.acompanhamentoProvider.getStatusFinalizar().subscribe((data) => {
      this.statusList = data;
    });
  }

  ngOnInit() {}

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  onSubmit() {}

  salvar() {
    this.submitted = true;
    this.validateAllFormFields(this.validations_form);

    if (this.validations_form.valid) {
      const validation = this.validations_form.value;
      this.acompanhamentoProvider
        .finalizarAcompanhamento(this.acompanhamento.id, validation.idAcompanhamentoStatus, validation.descricao)
        .subscribe(async () => {
          const result = this.statusList.find(
            (status: { id: string }) => status.id == validation.idAcompanhamentoStatus
          );

          this.modalCtrl.dismiss({
            tipo: result.tipo,
            status: result.nome,
          });

          const toast = await this.toastCtrl.create({
            message: this.translate.instant("Acompanhamento finalizado com sucesso"),
            duration: 3000,
          });

          toast.present();
        });
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
